import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.css']
})
export class SurveyComponent implements OnInit {
  link:any;

  constructor(public toastService:ToastrService, public loginService:LoginService, public sanitizer: DomSanitizer) { }

  ngOnInit() {
    // setTimeout(()=>{
    //   this.load();
    // },1000);
  }
  load(){
    let dt:any;
    this.loginService.staticData.get('SurveyLinks').forEach((element)=>{
      if((new Date(element.activeBeginDt)<= new Date()) && (new Date(element.activeEndDt)>= new Date()) && (element.activeSW == 'Y')){
        if((dt == undefined) || (dt > new Date(element.activeEndDt))){
          dt = new Date(element.activeEndDt);
          this.link = element.name;
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/survey/survey.component.ts